import { FormattedDate, FormattedMessage, FormattedNumber, FormattedTime } from 'react-intl';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { TableCell } from '@material-ui/core';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import DataTable from '../../../../components/DataTable_v2/DataTable';
import usePagination from '../../../../hooks/usePagination';
import { getClosureStatsAction } from './Closures/actions';
import useReduxReducer from '../../../../hooks/useReduxReducer';
import closures from './Closures/reducers';
import { LOADING, SUCCESS } from '../../../../enums/states';

const closureColumns = [
  {
    id: 'createdOn',
    label: <FormattedMessage id={'postedTransaction.closedOn'} />,
    align: 'left',
  },
  {
    id: 'documentNo',
    label: <FormattedMessage id={'transaction.documentNo'} />,
    align: 'left',
  },
  {
    id: 'createdBy',
    label: <FormattedMessage id={'transaction.createdBy'} />,
    align: 'left',
  },
  {
    id: 'transactionCount',
    label: <FormattedMessage id={'closure.transactionCount'} />,
    align: 'right',
  },
  {
    id: 'taxAmount',
    label: <FormattedMessage id={'closure.taxAmount'} />,
    align: 'right',
  },
  {
    id: 'netAmount',
    label: <FormattedMessage id={'closure.netAmount'} />,
    align: 'right',
  },
  {
    id: 'grossAmount',
    label: <FormattedMessage id={'closure.grossAmount'} />,
    align: 'right',
  },
  {
    id: 'action',
    label: '',
    align: 'right',
  },
];

const Closures = () => {
  const history = useHistory();
  useReduxReducer({ closures });
  const dispatch = useDispatch();
  const { page, onChangePage, rowsPerPage, onChangeRowsPerPage } = usePagination({});
  const closuresRedux = useSelector((state) => state?.closures);

  const [data, setData] = useState([]);

  useEffect(() => {
    dispatch(getClosureStatsAction(page, rowsPerPage));
  }, [page, rowsPerPage, dispatch]);

  useEffect(() => {
    if (closuresRedux?.metadata?.fetchingData?.status === SUCCESS) {
      const reformattedData = closuresRedux?.data?.transactions?.map(item => {
        return {
          ID: item.ID,
          createdOn: new Date(item.createdOn),
          documentNo: item.documentNo,
          name: item.name,
          transactionCount: item.transactionCount,
          taxAmount: item.taxAmount,
          netAmount: item.grossAmount - item.taxAmount,
          grossAmount: item.grossAmount,
        };
      });

      setData(reformattedData);
    }
  }, [closuresRedux]);

  return <DataTable
    loading={closuresRedux?.metadata?.fetchingData?.status === LOADING}
    columns={closureColumns}
    data={data}
    onRowClick={(row) => {
      history.push(`/closure/${row.ID}`);
    }}
    pagination
    page={page}
    count={closuresRedux?.data?.count || 0}
    rowsPerPage={rowsPerPage}
    onChangePage={onChangePage}
    onChangeRowsPerPage={onChangeRowsPerPage}
    template={ClosureRowTemplate}
  />;

};

export default Closures;

const ClosureRowTemplate = (props) => {
  const { createdOn, documentNo, name, transactionCount, grossAmount, taxAmount, netAmount } = props;
  return <>
    <TableCell>
      <>
        <FormattedDate value={createdOn} /> <FormattedTime value={createdOn} />
      </>
    </TableCell>
    <TableCell>{documentNo}</TableCell>
    <TableCell>{name}</TableCell>
    <TableCell style={{ textAlign: 'right' }}>{transactionCount}</TableCell>
    <TableCell style={{ textAlign: 'right' }}>
      <FormattedNumber value={taxAmount || 0} currency={'CZK'} {...{ style: 'currency' }} />
    </TableCell>
    <TableCell style={{ textAlign: 'right' }}>
      <FormattedNumber value={netAmount || 0} currency={'CZK'} {...{ style: 'currency' }} />
    </TableCell>
    <TableCell style={{ textAlign: 'right' }}>
      <FormattedNumber value={grossAmount || 0} currency={'CZK'} {...{ style: 'currency' }} />
    </TableCell>
    <TableCell><ArrowForwardIcon /></TableCell>
  </>;
};
